import {
  SHELF_CONTAINER_IDS,
  ITEM_TYPES,
  ACCEDO_CONTROL_CONTAINER_TEMPLATES,
  ROUTES
} from '#/config/constants';

import CarouselShelf from './CarouselShelf/CarouselShelf';
import GridShelf from './GridShelf/GridShelf';
import HeroShelf from './HeroShelf/HeroShelf';
import BannerShelf from './BannerShelf/BannerShelf';
import ChannelBannerShelf from './ChannelBannerShelf/ChannelBannerShelf';
import ChannelBannerImageShelf from './ChannelBannerImageShelf/ChannelBannerImageShelf';
import FilterableShelf from './FilterableShelf/FilterableShelf';

import GridSkeleton from '../Skeletons/GridSkeleton';
import HeroSkeleton from '../Skeletons/HeroSkeleton';

const ALIGNMENTS = {
  VERTICAL: 'grid-align-vertical',
  HORIZONTAL: 'grid-align-horizontal'
};

const determineItemTypeByRoute = (route, containerTemplate) => {
  switch (route) {
    case ROUTES.home:
    case ROUTES.bell:
    case ROUTES.tsn:
    case ROUTES.crave:
    case ROUTES.vod:
      break;
    default:
      return null;
  }

  if (containerTemplate.includes('portrait')) {
    return ITEM_TYPES.PortraitBell;
  }

  if (containerTemplate.includes('landscape')) {
    return ITEM_TYPES.WideBell;
  }

  if (containerTemplate.includes('wide')) {
    return ITEM_TYPES.WideBell;
  }

  return null;
};

// TODO: update based on the constants on ACCEDO_CONTROL_CONTAINER_TEMPLATES
const determineItemTypeByTemplate = containerTemplate => {
  if (
    containerTemplate ===
    ACCEDO_CONTROL_CONTAINER_TEMPLATES.carouselPortraitBell
  ) {
    return ITEM_TYPES.PortraitBell;
  }

  if (
    containerTemplate === ACCEDO_CONTROL_CONTAINER_TEMPLATES.carouselWideBell
  ) {
    return ITEM_TYPES.WideBell;
  }

  if (containerTemplate.includes('continue-watching')) {
    return ITEM_TYPES.Bookmark;
  }

  if (containerTemplate.includes('carousel-categories')) {
    return ITEM_TYPES.Categories;
  }

  if (containerTemplate.includes('carousel-category-portrait')) {
    return ITEM_TYPES.Categories;
  }

  if (containerTemplate.includes('grid-portrait')) {
    return ITEM_TYPES.Portrait;
  }

  if (containerTemplate.includes('featured-carousel-portrait')) {
    return ITEM_TYPES.FeaturedCarouselPortrait;
  }

  if (containerTemplate.includes('portrait')) {
    return ITEM_TYPES.Portrait;
  }

  if (containerTemplate.includes('landscape')) {
    return ITEM_TYPES.Landscape;
  }

  if (containerTemplate.includes('grid-vertical-wide')) {
    return ITEM_TYPES.GridLandscape;
  }

  if (containerTemplate.includes('wide')) {
    return ITEM_TYPES.Wide;
  }

  return ITEM_TYPES.Square;
};

const determineAligment = template => {
  if (template === 'grid-portrait' || template.includes('vertical')) {
    return ALIGNMENTS.VERTICAL;
  }
  return ALIGNMENTS.HORIZONTAL;
};

const CONTAINER_ID_TO_COMPONENT_MAP = {
  [SHELF_CONTAINER_IDS.Carousel]: CarouselShelf,
  [SHELF_CONTAINER_IDS.Default]: GridShelf,
  [SHELF_CONTAINER_IDS.Grid]: GridShelf,
  [SHELF_CONTAINER_IDS.HeroBanner]: HeroShelf,
  [SHELF_CONTAINER_IDS.ImageHeroBanner]: BannerShelf,
  [SHELF_CONTAINER_IDS.ChannelBanner]: ChannelBannerShelf,
  [SHELF_CONTAINER_IDS.ChannelBannerImage]: ChannelBannerImageShelf,
  [SHELF_CONTAINER_IDS.FilterSort]: FilterableShelf
};

const CONTAINER_ID_TO_SKELETON_COMPONENT_MAP = {
  [SHELF_CONTAINER_IDS.Carousel]: GridSkeleton,
  [SHELF_CONTAINER_IDS.Default]: GridSkeleton,
  [SHELF_CONTAINER_IDS.Grid]: GridSkeleton,
  [SHELF_CONTAINER_IDS.HeroBanner]: HeroSkeleton,
  [SHELF_CONTAINER_IDS.ImageHeroBanner]: HeroSkeleton
};

const isContianerIDCarousel = containerId =>
  containerId === SHELF_CONTAINER_IDS.Carousel;

export {
  determineItemTypeByRoute,
  determineItemTypeByTemplate,
  determineAligment,
  isContianerIDCarousel,
  CONTAINER_ID_TO_COMPONENT_MAP,
  CONTAINER_ID_TO_SKELETON_COMPONENT_MAP
};
